import DatasetTypesAPI from "@/api/DatasetTypesAPI"
import JohnDeereAPI from "@/api/JohnDeereAPI"
import UploadsAPI from "@/api/UploadsAPI"
import { IS_RANCHFORCE } from "@/constants/index"
import { Uploads } from "."

const state = {
  accountConnections: {},
  datasetTypes: [],
  johnDeereStatus: null,
  uploads: null,
  uploadPercentage: 0,
  detailsModalUploadID: null,
  detailsModalUploadFieldID: null,
  mappingModalUploadID: null,
  aggriwebData: [],
  pastureId: null,
}

const getters = {}
console.log("ACTION =", Uploads.Actions.getUserAgriAPIKey)

const mutations = {
  [Uploads.Mutations.setAccountConnections](state, connections) {
    const connectionsDict = {}
    connections.forEach(item => (connectionsDict[item.connection] = item))
    state.accountConnections = connectionsDict
  },

  [Uploads.Mutations.setPastureId](state, id) {
    state.pastureId = id
  },

  [Uploads.Mutations.setDatasetTypes](state, datasetTypes) {
    state.datasetTypes = [...datasetTypes]
  },

  [Uploads.Mutations.setDetailsModalUploadID](state, id) {
    state.detailsModalUploadID = id
  },

  [Uploads.Mutations.setDetailsModalUploadFieldID](state, id) {
    state.detailsModalUploadFieldID = id
  },

  [Uploads.Mutations.setJohnDeereStage](state, payload) {
    state.johnDeereStatus = payload
  },

  [Uploads.Mutations.setMappingModalUploadID](state, id) {
    state.mappingModalUploadID = id
  },

  [Uploads.Mutations.setUploads](state, uploads) {
    state.uploads = [...uploads]
  },

  [Uploads.Mutations.setUploadPercentage](state, uploadPercentage) {
    state.uploadPercentage = uploadPercentage
  },
  [Uploads.Mutations.setAgriWebData](state, data) {
    state.aggriwebData = data
  },
}

const actions = {
  [Uploads.Actions.create](_, { orgId, datasetType, file, specs = null, pastureId = undefined }) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append("organization_node_id", orgId)
      formData.append("dataset_type", datasetType)
      formData.append("raw_data", file)

      if (datasetType === "practice-confirmations" && specs != null) {
        const {
          createNewConfirmation,
          confirmationNumbers,
          confirmationSource = null,
          usedOtherConfirmationSourceOption = null,
          type = null,
          crops = null,
          year = null,
          farms = null,
          fields = null,
          client = null,
        } = specs

        formData.append("create_new_confirmation", createNewConfirmation)

        if (usedOtherConfirmationSourceOption != null)
          formData.append(
            "used_other_confirmation_source_option",
            usedOtherConfirmationSourceOption
          )
        if (confirmationNumbers != null)
          formData.append("confirmation_numbers", confirmationNumbers)
        if (confirmationSource != null)
          formData.append("confirmation_source", confirmationSource)
        if (type != null) formData.append("confirmation_type", type)
        if (fields != null) formData.append("fields", fields)
        if (farms != null) formData.append("farms", farms)
        if (client != null) formData.append("client", client)
        if (crops != null) formData.append("crops", crops)
        if (year != null) formData.append("year", year)
      }

      if (datasetType === "move-client" && specs != null) {
        formData.append("user_id", specs.userId)
        formData.append("move_client_action_id", specs.moveClientActionId)
      }

      if (datasetType == 'import-enrichedag-ranching-data') {
        formData.append("pasture_id", pastureId)
        UploadsAPI.postPasture(formData).then(resolve).catch((error) => {
          reject(error.response.data)
        })
      } else {
        UploadsAPI.post(formData).then(resolve)
      }
    })
  },
  [Uploads.Actions.createFieldRow](_, { orgId, datasetType, file, specs = null }) {
    return new Promise(resolve => {
      const formData = new FormData()
      const {
        fieldRowData,
        note,
        confirmationSource,
      } = specs

      formData.append("organization_node_id", orgId)
      formData.append("dataset_type", datasetType)
      formData.append("raw_data", file)
      if (fieldRowData != null) formData.append("fieldRowData", JSON.stringify(fieldRowData))
      if (note != null) formData.append("note", note)
      if (confirmationSource != null) formData.append("confirmationSource", confirmationSource)
      UploadsAPI.uploadEvidencing(formData).then(resolve)
    })
  },

  [Uploads.Actions.createEnrich](_, { orgId, datasetType, file, pasture_name }) {
    return new Promise(resolve => {
      const formData = new FormData()

      formData.append("organization_node_id", orgId)
      formData.append("dataset_type", datasetType)
      formData.append("raw_data", file)
      formData.append("pasture_name", pasture_name)
      UploadsAPI.uploadEnrich(formData).then(resolve)
    })
  },

  [Uploads.Actions.updateBoundary](_, { orgId, datasetType, file, fieldName }) {
    return new Promise(resolve => {
      const formData = new FormData()
      formData.append("organization_node_id", orgId)
      formData.append("dataset_type", datasetType)
      formData.append("raw_data", file)
      formData.append("field_name", fieldName)
      UploadsAPI.updateBoundary(formData).then(resolve)
    })
  },

  [Uploads.Actions.updateRanchBoundary](_, { orgId, datasetType, file, fieldName, fieldId }) {
    return new Promise(resolve => {
      const formData = new FormData()
      formData.append("organization_node_id", orgId)
      formData.append("dataset_type", datasetType)
      formData.append("raw_data", file)
      formData.append("field_name", fieldName)
      if (fieldId != null) {
        formData.append("field_id", fieldId)
      }
      UploadsAPI.updateRanchBoundary(formData).then(resolve)
    })
  },

  [Uploads.Actions.updateRanchPaddocks](_, { orgId, fieldId, datasetType, file, paddockName }) {
    return new Promise(resolve => {
      const formData = new FormData()
      formData.append("dataset_type", datasetType)
      formData.append("raw_data", file)
      if (fieldId != null) {
        formData.append("field_id", fieldId)
      }
      UploadsAPI.updateRanchPaddocks(formData).then(resolve)
    })
  },

  [Uploads.Actions.fetch]({ commit }, currentPage) {
    let payload = {
      importSource: localStorage.getItem("dataImportSource"),
      currentPage: currentPage,
    }
    return new Promise(resolve => {
      UploadsAPI.get(payload).then(response => {
        // Github ticket 478: Data import page switches back from MyJD to MyComputer on the list of data imports
        //  Added this check to make sure we only setUploads for the correct tab that we're on.
        if (payload.importSource === localStorage.getItem("dataImportSource")) {
          commit(Uploads.Mutations.setUploads, response.data.results)
          resolve()
        }
      })
    })
  },

  [Uploads.Actions.fetchJohnDeereStage]({ commit }) {
    return new Promise(resolve => {
      JohnDeereAPI.fetchJohnDeereStage().then(response => {
        commit(Uploads.Mutations.setJohnDeereStage, response.data)
        resolve()
      })
    })
  },

  [Uploads.Actions.listDatasetTypes]({ commit }) {
    if (IS_RANCHFORCE) {
      return new Promise(resolve => {
        DatasetTypesAPI.getPasture().then(response => {
          commit(Uploads.Mutations.setDatasetTypes, response.data)
          resolve()
        })
      })
    } else {
      return new Promise(resolve => {
        DatasetTypesAPI.get().then(response => {
          let dataTypes = response.data
          if (IS_RANCHFORCE) {
            dataTypes = dataTypes.filter((t) => t.name != "Ranching/Feeding Data")
          }
          commit(Uploads.Mutations.setDatasetTypes, dataTypes)
          resolve()
        })
      })
    }
  },
  [Uploads.Actions.fetchAgriWebData]({ commit }, agriwebbPastureId) {
    return new Promise((resolve, reject) => {
      UploadsAPI.getAgriWebData(agriwebbPastureId)
        .then(response => {
          commit(Uploads.Mutations.setAgriWebData, response.data)
          resolve(response.data)
        })
        .catch(error => {
          console.error("Error fetching AgriWeb data:", error)
          reject(error)
        })
    })
  },
  [Uploads.Actions.importShipFile](_, { farmId }) {
    return new Promise(resolve => {
      const payload = {
        farm_id: farmId
      }
      UploadsAPI.shipFileImport(payload).then(resolve)
    })
  },
  [Uploads.Actions.getUserAgriAPIKey]() {
    return new Promise((resolve, reject) => {
      UploadsAPI.getUserAgriwebbAPIKey()
        .then(response => resolve(response.data))
        .catch(error => {
          console.log("Error getting agriwebb API key", error)
          reject(error)
        })
    })
  },
  [Uploads.Actions.createUserAgriwebbAPIKey](_, { agriwebbAPIKey }) {
    return new Promise((resolve, reject) => {
      UploadsAPI.createUserAgriwebbAPIKey({
          agriwebb_api_key: agriwebbAPIKey
        })
        .then(response => resolve(response.data))
        .catch(error => {
          console.lo("Error creating agriwebb API key", error)
          reject(error)
        })
    })
  },
  [Uploads.Actions.getAgriwebbPastureOptions]() {
    return new Promise((resolve, reject) => {
      UploadsAPI.getAgriwebbPastureOptions()
        .then(response => resolve(response.data))
        .catch(error => {
          console.lo("Error fetching agriwebb pasture options", error)
          reject(error)
        })
    })
  },
  [Uploads.Actions.createImpprtEnrichedData](_, { orgId, datasetType, specs = null, pastureId = undefined, forageFiles, herdFiles }) {
    return new Promise((resolve, reject) => {
      const formData = new FormData()
      formData.append("organization_node_id", orgId)
      formData.append("dataset_type", datasetType)
      formData.append("pasture_id", pastureId)

      if (!herdFiles.length) {
        forageFiles.forEach((item) => {
          formData.append("raw_data", item.file)
        })
        
        UploadsAPI.postPasture(formData).then(resolve).catch((error) => {
          reject(error.response.data)
        })
      } else {
        forageFiles.forEach((item) => {
          formData.append("raw_data", item.file)
        })

        herdFiles.forEach((herdFile) => {
          formData.append("herd_files", herdFile.file.file)      // flat key for FILES.getlist()
          formData.append("herd_species", herdFile.species) // parallel array
          formData.append("herd_animals", herdFile.animals) // parallel array
        })

        UploadsAPI.postPastureHerd(formData).then(resolve).catch((error) => {
          reject(error.response.data)
        }) 
      }
    })
  }
  
}

console.log("ACTION =", Uploads.Actions.getUserAgriAPIKey)


export default {
  state,
  getters,
  mutations,
  actions,
}
